import {
  DeactivateAllAdUnitsProductMutation,
  DeactivateAllAdUnitsProductMutationVariables,
} from 'gql/graphql'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { useAdUnitsProductSnackbar } from '../useAdUnitsProductSnackbar'
import { DEACTIVATE_ALL_AD_UNITS_PRODUCT } from './mutation'

import type { UseDeactivateAllAdUnitsProduct } from './types'

export const useDeactivateAllAdUnitsProduct = (): UseDeactivateAllAdUnitsProduct => {
  const { snackbar } = useAdUnitsProductSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<
    DeactivateAllAdUnitsProductMutationVariables,
    DeactivateAllAdUnitsProductMutation
  >({
    mutation: DEACTIVATE_ALL_AD_UNITS_PRODUCT,
    onCompleted: async (
      data: DeactivateAllAdUnitsProductMutation,
      variables: DeactivateAllAdUnitsProductMutationVariables,
    ) => {
      const { deactivateAllAdUnitsProduct } = data
      const product = variables.input.productType

      if (deactivateAllAdUnitsProduct?.errors) {
        const { errors } = deactivateAllAdUnitsProduct

        if (errors && errors.length > 0) {
          snackbar({ enabled: false, product, variant: 'error' })
        }
      } else {
        snackbar({ enabled: false, product, variant: 'success' })
      }
    },
    queriesToInvalidate: ['getAdUnitsForTable'],
  })

  const deactivateAllAdUnitsProduct: UseDeactivateAllAdUnitsProduct['deactivateAllAdUnitsProduct'] =
    product => {
      void mutateAsync({
        input: {
          productType: product,
        },
      })
    }

  return { deactivateAllAdUnitsProduct, loading }
}
